module.exports = __webpack_public_path__ + "img/login_biaoti2.d79e1986.png";